import { action, observable } from "mobx";

import MainEntity from "domain/main/MainEntity";

/**
 * 시스템 - 타이틀 Entity
 */
export default abstract class TbSysTitleEntity extends MainEntity {
  @observable private titleCode: string = "";
  @observable private titleLocale: string = "";
  @observable private titleCn: string = "";

  public getTitleCode() {
    return this.titleCode;
  }

  @action
  public setTitleCode(titleCode: string): void {
    this.titleCode = titleCode;
  }

  public getTitleLocale() {
    return this.titleLocale;
  }

  @action
  public setTitleLocale(titleLocale: string): void {
    this.titleLocale = titleLocale;
  }

  public getTitleCn() {
    return this.titleCn;
  }

  @action
  public setTitleCn(titleCn: string): void {
    this.titleCn = titleCn;
  }
}
